import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { PostReportedUser } from '../modal';

export default function reducer(state: PostReportedUser = new PostReportedUser(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.POST_REPORT_DETAIL_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.POST_REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.POST_REPORT_DETAIL_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
